<div class="container" [hidden]="isLoading || !active" (window:resize)="onResize($event)">
    <div class="header-area">
        <div class="filter-area">
            <div class="filter" (click)="changeStatusFilter($event)">
                <div class="filter-label">{{'general.status' | stringLiterals}}:&nbsp;</div>
                <div class="filter-content dropdown-link">{{filterStatus}}</div>
                <tam-context-menu [config]="statusContextMenuConfig"></tam-context-menu>
            </div>
            <div class="filter" (click)="changeAssigneeFilter($event)">
                <div class="filter-label">Assignee:&nbsp;</div>
                <div class="filter-content dropdown-link">
                    {{assignToMe?'Current User':'Everyone'}}
                </div>
                <tam-context-menu [config]="assignContextMenuConfig"></tam-context-menu>
            </div>
        </div>
        <div class="action-area" kendoTooltip position="bottom">
            <smart-icon name="refresh" class="light refresh" title="Refresh" (click)="onRefreshClicked()">
            </smart-icon>
            <div class="view-change" (click)="onChangeView($event)">
                <smart-icon *ngIf="isKanbanView" name="kanban" class="light"></smart-icon>
                <smart-icon *ngIf="isGridView" name="grid" class="light"></smart-icon>
            </div>
            <tam-context-menu [config]="actionContextMenuConfig"></tam-context-menu>
        </div>
    </div>
    <div [hidden]="isGridView" class="body-area">
        <div class="group-info-area" kendoTooltip tooltipClass="tooltip-adjust-right">
            <div class="one-group"
                *ngFor="let item of sortedGroupList.slice(firstGroupIndex,lastGroupIndex);index as i">
                <div class="text-ellipsis group-name" [title]="item.name">{{item.name}}</div>
                <div class="group-count">({{getTaskCount(i+firstGroupIndex)}})</div>
            </div>
        </div>
        <div class="data-area">
            <div class="one-group-data" *ngFor="let group of groupedTaskList.slice(firstGroupIndex,lastGroupIndex)">
                <div class="data-list-area">
                    <kanban-task-card class="one-data" *ngFor="let item of group;index as i;trackBy:trackByFn"
                        [task]="item" [config]="taskCardConfig" (click)="onSelectTask($event,item)">
                    </kanban-task-card>
                </div>
            </div>
            <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
        </div>
        <div class="arrow-left" *ngIf="firstGroupIndex>0" (click)="lastPage($event)">
            <smart-icon name="arrow-left"></smart-icon>
        </div>
        <div class="arrow-right" *ngIf="lastGroupIndex!==groupCount" (click)="nextPage($event)">
            <smart-icon name="arrow-right"></smart-icon>
        </div>
    </div>
    <div [hidden]="isKanbanView" class="body-area" (mousedown)="onMousedown($event)">
        <ag-grid-angular class="ag-theme-balham" style="width: 100%; height: 100%;" [columnDefs]="columnDefs"
            [components]="frameworkComponents" [gridOptions]="gridOptions" [groupDefaultExpanded]="-1"
            [groupRowInnerRenderer]="groupRowInnerRenderer" [groupRowRendererParams]="groupRowRendererParams"
            [rowData]="data" (bodyScroll)="onBodyScroll($event)" (columnMoved)="onColumnMoved($event)"
            (columnPinned)="onColumnPinned($event)" (columnResized)="onColumnResized($event)"
            (columnRowGroupChanged)="onColumnRowGroupChanged($event)" (columnVisible)="onColumnVisible($event)"
            [getRowNodeId]="getRowNodeId" (filterChanged)="onFilterChanged()" (gridReady)="onGridReady($event)"
            (rowClicked)="onRowSelected($event)">
        </ag-grid-angular>
    </div>
</div>